"use client";

/** Official Mini App API: native prompt for the current user's own number. */
export function requestOwnTelegramPhone(onShared: (shared: boolean) => void): boolean {
  const tg = window.Telegram?.WebApp;
  tg?.ready?.();

  if (typeof tg?.requestContact === "function") {
    tg.requestContact((shared) => {
      onShared(Boolean(shared));
    });
    return true;
  }

  const proxy = (
    window as Window & {
      TelegramWebviewProxy?: { postEvent?: (event: string, data?: string) => void };
    }
  ).TelegramWebviewProxy;
  if (typeof proxy?.postEvent === "function") {
    proxy.postEvent("web_app_request_phone", "");
    tg?.onEvent?.("contactRequested", function onEvent(event) {
      tg.offEvent?.("contactRequested", onEvent);
      const status = event && typeof event === "object" && "status" in event ? event.status : undefined;
      onShared(status === "sent");
    });
    return true;
  }

  return false;
}

export function wait(ms: number) {
  return new Promise((resolve) => window.setTimeout(resolve, ms));
}

export function openTelegramUrl(url: string) {
  const open = window.Telegram?.WebApp?.openTelegramLink;
  if (url.startsWith("https://t.me/") && typeof open === "function") {
    open(url);
    return;
  }
  window.location.href = url;
}

export function openExternalUrl(url: string) {
  const openLink = window.Telegram?.WebApp?.openLink;
  if (typeof openLink === "function") {
    openLink(url);
    return;
  }
  window.open(url, "_blank", "noopener,noreferrer");
}
